import { AfterViewInit, ChangeDetectionStrategy, Component, OnChanges, OnInit, SimpleChanges, input, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { UserMemberService } from 'src/app/services/user-member.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class UserComponent implements OnInit, OnChanges, AfterViewInit {
  user_id = input.required<number>();
  edit_contact = signal<boolean>(false);
  edit_availability = signal<boolean>(false);
  edit_skills = signal<boolean>(false);
  refreshUser = new Subject<void>();
  user: any;
  currentUser: any;
  assignmentList: any[] = [];
  positionList: any[] = [];
  editable: boolean = false;
  selfEditable: boolean = false;
  isAdmin: boolean = false;

  available_personal: string = "true";
  fragment: any;

  user_relations = ["assessments", "skills", "reportMembers.report.assessment", "reportMembers.skills", "agency", "baer_roles.baer_role"] // constant

  constructor(
    private readonly userService: UserService,
    private readonly userMemberService: UserMemberService,
    private readonly titleService: Title,
    private readonly route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.fragment.subscribe((fragment) => {
      this.fragment = fragment;
    });
  }

  ngAfterViewInit(): void {
    this.route.fragment.subscribe(f => {
      const element = document.querySelector("#" + f)
      if (element) element.scrollIntoView()
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.userService.getUserProfile().then((user) => {
      this.currentUser = user;
      this.loadUserInfo();
    })
  }

  loadUserInfo() {
    let user_id = this.user_id();
    if ((this.user_id() ?? 0) == 0)
      user_id = this.currentUser.user_id;
    this.userService.getUser(user_id, this.user_relations).subscribe((data) => {
      this.user = data.users[0];
      this.sortFlattenAssessments(this.user)
      this.available_personal = String(this.user.available_personal ?? true);

      if (this.user.user_id == this.currentUser.user_id || !!this.currentUser.isWO || this.currentUser.isROCO?.length > 0) {
        this.selfEditable = true;
        this.editable = true;
        this.titleService.setTitle("BAER - My Profile")
      }
      else {
        this.titleService.setTitle("BAER - " + data.users[0].first_name + ' ' + data.users[0].last_name)
      }
      if (this.currentUser.isCO) this.editable = true;
      if (this.currentUser.isWO) this.isAdmin = true;

      let assignmentTempList: any[] = [];

      for (let reportMember of this.user.reportMembers) {
        assignmentTempList.push({
          'assessment_id': reportMember.report.assessment_id,
          'baer_name': reportMember.report.assessment.baer_name + ' (' + reportMember.report.report_num + ')',
          'report_id': reportMember.report.report_id,
          'forest_name': reportMember.report.assessment.forest_name,
          'skills': reportMember.skills,
          'start_date': reportMember.report.assessment.tentative_start_week,
          'close_date': reportMember.report.assessment.close_out_date,
        })
      }
      for (let assessment of this.user.assessments) {
        if (!assignmentTempList.find((assignment: any) => assignment.assessment_id == assessment.assessment_id))
          assignmentTempList.push({
            'assessment_id': assessment.assessment_id,
            'baer_name': assessment.baer_name,
            'report_id': 'N/A',
            'forest_name': assessment.forest_name,
            'skills': [],
            'start_date': assessment.tentative_start_week,
            'close_date': assessment.close_out_date,
          })
      }
      this.assignmentList = assignmentTempList;
      this.setPositionList();
    })

    // Refreshes user when .next() is called on refreshUser
    this.refreshUser.asObservable().subscribe(() => {
      this.loadUserInfo();
    })
  }

  setPositionList() {
    let positionList;
    positionList = this.user.baer_roles;
    positionList.forEach((position: any) => {
      if (position.location_id == null || position.baer_role_id == 2) {
        position.location_id = this.user.location_id;
        position.region = this.user.region;
        position.forest_name = this.user.forest_name;
      }
    })
    this.positionList = positionList;

  }

  availabilityChanged() {
    let available_personal: boolean | null | undefined = (this.available_personal == "true")

    this.userService.editUserDetails({
      user_id: this.user.user_id,
      available_personal: available_personal,
    }).subscribe({
      next: (response) => {
      },
      error: (response) => {
        console.log("There was an error updating the user.", "Please try again.");
      },
    })
  }

  sortFlattenAssessments(user: any) {
    const today = new Date();
    let assessments: any = [];
    let filteredMembers = user.reportMembers.filter((x: any) => !x.demobilize)
    let filteredReports: any[] = []
    filteredMembers.forEach((x: any) => filteredReports.push(x.report));
    assessments = [...assessments, ...user.assessments];
    for (let report of filteredReports) {
      assessments = [...assessments, ...[report.assessment]];
    }
    assessments = assessments.filter((x: any) => (new Date(x.close_out_date)) > today);
    assessments.sort((a: any, b: any) => a.close_out_date > b.close_out_date);
    user.filteredAssessment = assessments[0];

    let tooltip = '';
    if (user.filteredAssessment) {
      tooltip = 'Fire Assignment:\nFire name: ' + user.filteredAssessment.baer_name
      tooltip += '\nStart Date: ' + (new Date(user.filteredAssessment.tentative_start_week)).toLocaleDateString("en-US")
      tooltip += '\nClose Out: ' + (new Date(user.filteredAssessment.close_out_date)).toLocaleDateString("en-US")
    }
    user.assessmentTooltip = tooltip;
  }

  subLoaded() {
    if (this.fragment == 'assignments') {
      let element = document.getElementById('assignments')
      element?.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" })
    }
  }
}
